"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const react_redux_1 = require("react-redux");
const expertsSlice_1 = require("../../../../../../../redux/slices/expertsSlice");
const modalsSlice_1 = require("../../../../../../../redux/slices/modalsSlice");
require("./expertize.scss");
const PlusIcon_1 = __importDefault(require("../../../../../../../svgIcons/PlusIcon"));
const Expertize = (props) => {
    const { expert } = props;
    const { areas } = expert;
    const handleDelete = (event, index) => {
        const deletedAreas = (expert.deletedAreas ? expert.deletedAreas.slice() : []);
        deletedAreas.push(expert.areas[index].id);
        const updatedAreas = (expert.areas.slice());
        updatedAreas.splice(index, 1);
        props.editExpert({
            key: 'areas',
            val: updatedAreas
        });
        props.editExpert({
            key: 'deletedAreas',
            val: deletedAreas
        });
    };
    const openModal = () => props.triggerModal({ key: 'experts.expertize', val: true });
    return expert && areas ? (react_1.default.createElement(core_1.Paper, { className: 'paper admin-blocks expertize', square: true },
        react_1.default.createElement("div", { className: "header-add" },
            react_1.default.createElement("h5", { className: "mb-0" }, "Areas of Expertise"),
            react_1.default.createElement("div", { className: 'align-right' },
                react_1.default.createElement(core_1.Button, { className: "v2-btn-icon-link ", onClick: () => openModal(), variant: 'text', startIcon: react_1.default.createElement(PlusIcon_1.default, null), disableRipple: true }, "Add"))),
        react_1.default.createElement(core_1.Grid, { container: true, spacing: 3, className: "mt-0" },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, className: "expertize-item" },
                react_1.default.createElement("ul", { className: "expertize-list" }, areas.length ? areas.map((data, key) => {
                    return (react_1.default.createElement("li", { key: key },
                        react_1.default.createElement(core_1.Chip, { className: "expertize-chip-item", label: data.name, onDelete: (data) => handleDelete(data, key) })));
                }) : react_1.default.createElement("p", { className: "m-0 pl-5" }, "Please add areas of expertise to complete your profile")))))) : (react_1.default.createElement(react_1.Fragment, null));
};
const mapStateToProps = (state) => {
    const { experts } = state;
    return {
        expert: experts.editableExpert || experts.expert
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        editExpert: (data) => dispatch(expertsSlice_1.editExpert(data)),
        triggerModal: (data) => dispatch(modalsSlice_1.triggerModal(data)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(Expertize);
